import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/layout/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Usage`}</h2>
    <p>{`Buttons are used to initiate an action or trigger the user to open a link.`}</p>
    <p>{`Use Legion Button styles for actions in forms, dialogs, and more with support lots type and attribute for costumize.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import LegionUI
`}</code></pre>
    <div className="divi" />
    <h2>{`Variant`}</h2>
    <div>{`
  `}<img parentName="div" {...{
        "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2Fb12f168d-a0d7-4791-bf9c-5255689e1e1d%2FScreen_Shot_2022-11-11_at_2.49.56_PM.png?table=block&id=68abd099-3948-4292-a069-4c0e1076b419&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=1340&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
      }}></img>
    </div>
    <p>{`Use this Function : `}<inlineCode parentName="p">{`LGNSolidBtn`}</inlineCode>{`, `}<inlineCode parentName="p">{`LGNOutlineBtn`}</inlineCode>{`, `}<inlineCode parentName="p">{`LGNSoftBtn`}</inlineCode>{`, `}<inlineCode parentName="p">{`LGNTransparentBtn`}</inlineCode>{` and add `}<inlineCode parentName="p">{`title`}</inlineCode>{` for the text of the button.`}</p>
    <p>{`This code sample demonstrates how to modify the variant of the button :`}</p>
    <p>{`A. Solid Button`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSolidBtn(title: "Solid")
`}</code></pre>
    <p>{`B. Outline Button`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNOutlineBtn(title: "Outline")
`}</code></pre>
    <p>{`C. Soft Button`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSoftBtn(title: "Soft")
`}</code></pre>
    <p>{`D. Transparent Button`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNTransparentBtn(title: "Transparent")
`}</code></pre>
    <div className="divi" />
    <h2>{`Attribute`}</h2>
    <p>{`Legion Have 5 Attributes for Customize Button :`}</p>
    <h3><strong parentName="h3">{` Size `}</strong></h3>
    <p>{`This size text button attribute for user to choose size text inside the button.`}</p>
    <div {...{
      "className": "wrapper-display-component-three",
      "style": {
        "backgroundColor": "white"
      }
    }}>{`
  `}<div parentName="div" {...{
        "className": "item-three"
      }}>{`
    `}<div parentName="div" {...{
          "style": {
            "textAlign": "left"
          }
        }}>{`Small`}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F666f2018-7e4e-4e46-9cc0-6ce995e97dc1%2FUntitled.png?table=block&id=b87c8a86-33c4-4230-8a19-45911f0db26d&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=770&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F2fec5730-61a8-411d-beb2-89510f72aa0e%2FUntitled.png?table=block&id=16564e21-dd2c-4a59-a275-f74faca61fa9&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=670&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2Fc4844221-75c8-4077-8adf-57fb2738e84d%2FUntitled.png?table=block&id=303f2a0a-5bc8-4ffa-85ae-28dd9f1f2e43&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=770&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2Fc9234e70-d637-4a7d-a33b-9b01b8194768%2FUntitled.png?table=block&id=2de7585f-4ba2-4186-8766-1653b3b8f44d&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=770&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
  `}</div>{`
  `}<div parentName="div" {...{
        "className": "item-three"
      }}>{`
    `}<div parentName="div" {...{
          "style": {
            "textAlign": "left"
          }
        }}>{`Normal`}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2Fbc67ca11-5f04-49dc-b15b-c7aeada87af4%2FUntitled.png?table=block&id=e8b047f6-6747-4c0f-bbe4-22d396c9b144&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=780&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F253d9885-015f-4911-957a-b7f21ff27690%2FUntitled.png?table=block&id=8b6b48be-b198-4ef1-85a9-9c8dcc36dd61&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=770&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F8fa213c5-25f1-42c2-8914-94f5ef5d41d5%2FUntitled.png?table=block&id=2eeb29a5-13e3-4bac-935b-c9c8984ddb68&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=780&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F2572505f-df40-4034-9af5-9bd506505fa1%2FUntitled.png?table=block&id=89663c23-7e51-4a37-9934-0d77b7a65ce7&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=760&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
  `}</div>
    </div>
    <p>{`Choose type botton : `}<inlineCode parentName="p">{`LGNSolidBtn`}</inlineCode>{`, `}<inlineCode parentName="p">{`LGNOutlineBtn`}</inlineCode>{`, `}<inlineCode parentName="p">{`LGNSoftBtn`}</inlineCode>{`, `}<inlineCode parentName="p">{`LGNTransparentBtn`}</inlineCode>{` and Use this Function : `}<inlineCode parentName="p">{`.variant(size: SizeBtn)`}</inlineCode>{`, where the `}<inlineCode parentName="p">{`SizeBtnconsists`}</inlineCode>{` of `}<inlineCode parentName="p">{`normal`}</inlineCode>{`
and `}<inlineCode parentName="p">{`small`}</inlineCode></p>
    <p>{`This code sample demonstrates how to modify size text of the button :`}</p>
    <p>{`A. Solid Small`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSolidBtn(title: "Solid").variant(size: .small)
`}</code></pre>
    <p>{`B. Solid Normal`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSolidBtn(title: "Solid").variant(size: .normal)
`}</code></pre>
    <p>{`C. Outline Small`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNOutlineBtn(title: "Outline").variant(size: .small)
`}</code></pre>
    <p>{`D. Outline Normal`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNOutlineBtn(title: "Outline").variant(size: .normal)
`}</code></pre>
    <p>{`E. Soft Small`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSoftBtn(title: "Outline").variant(size: .small)
`}</code></pre>
    <p>{`F. Soft Normal`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSoftBtn(title: "Outline").variant(size: .normal)
`}</code></pre>
    <p>{`G. Transparent Small`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNTransparentBtn(title: "Outline").variant(size: .small)
`}</code></pre>
    <p>{`H. Transaparent Normal`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNTransparentBtn(title: "Outline").variant(size: .normal)
`}</code></pre>
    <h3><strong parentName="h3">{` Responsive `}</strong></h3>
    <p>{`This responsive button or boolean attribute for user to choose the button responsively to the screen / layout or not.`}</p>
    <div {...{
      "className": "wrapper-display-component-three",
      "style": {
        "backgroundColor": "white"
      }
    }}>{`
  `}<div parentName="div" {...{
        "className": "item-three"
      }}>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2Fdc51aa87-44b6-4238-9663-d0370c175b1b%2FUntitled.png?table=block&id=3ff191d1-6e27-4638-8a5f-a16abbcfb0b6&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=780&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F7f25993f-9dfc-4f9d-b5ca-e446857e47c5%2FUntitled.png?table=block&id=41302b37-fd05-4fde-90c3-8a75e77b5d19&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=770&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F7166d40d-5ac2-4e9d-9e67-828434cc6436%2FUntitled.png?table=block&id=0d98e629-35b1-494b-9d3e-40ba324c264e&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=770&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2Fbd16682d-511c-4c7f-a9e8-5566d3499d99%2FUntitled.png?table=block&id=39776bd3-ca1e-4447-bb71-a6897ba32e08&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=760&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "textAlign": "left"
          }
        }}>{`Responsive`}</div>{`
  `}</div>{`
  `}<div parentName="div" {...{
        "className": "item-three"
      }}>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2Fbc67ca11-5f04-49dc-b15b-c7aeada87af4%2FUntitled.png?table=block&id=e8b047f6-6747-4c0f-bbe4-22d396c9b144&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=780&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F253d9885-015f-4911-957a-b7f21ff27690%2FUntitled.png?table=block&id=8b6b48be-b198-4ef1-85a9-9c8dcc36dd61&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=770&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F8fa213c5-25f1-42c2-8914-94f5ef5d41d5%2FUntitled.png?table=block&id=2eeb29a5-13e3-4bac-935b-c9c8984ddb68&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=780&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F2572505f-df40-4034-9af5-9bd506505fa1%2FUntitled.png?table=block&id=89663c23-7e51-4a37-9934-0d77b7a65ce7&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=760&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "textAlign": "left"
          }
        }}>{`Not Responsive`}</div>{`
  `}</div>
    </div>
    <InlineNotification kind="warning" mdxType="InlineNotification">
  IOS Responsive can’t run if there is no size. Make sure you include the size!
    </InlineNotification>
    <p>{`Choose type botton : `}<inlineCode parentName="p">{`LGNSolidBtn`}</inlineCode>{`, `}<inlineCode parentName="p">{`LGNOutlineBtn`}</inlineCode>{`, `}<inlineCode parentName="p">{`LGNSoftBtn`}</inlineCode>{`, `}<inlineCode parentName="p">{`LGNTransparentBtn`}</inlineCode>{` and use this Function : `}<inlineCode parentName="p">{`.variant(size: SizeBtn)`}</inlineCode>{`, where the `}<inlineCode parentName="p">{`SizeBtn`}</inlineCode>{` consists of `}<inlineCode parentName="p">{`normal`}</inlineCode>{` or `}<inlineCode parentName="p">{`small`}</inlineCode>{` and `}<inlineCode parentName="p">{`responsive`}</inlineCode>{` for `}<inlineCode parentName="p">{`true`}</inlineCode>{` or `}<inlineCode parentName="p">{`false`}</inlineCode>{`
This code sample demonstrates how to modify responsive of the button :`}</p>
    <p>{`A. Solid Small Responsive`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSolidBtn(title: "Solid").variant(size: .small, responsive: true)
`}</code></pre>
    <p>{`B. Solid Small Not Responsive`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSolidBtn(title: "Solid").variant(size: .small, responsive: false)
`}</code></pre>
    <p>{`C. Solid Normal Responsive`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSolidBtn(title: "Solid").variant(size: .normal, responsive: true)
`}</code></pre>
    <p>{`D. Solid Normal Not Responsive`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSolidBtn(title: "Solid").variant(size: .normal, responsive: false)
`}</code></pre>
    <p>{`E. Outline Small Responsive`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNOutlineBtn(title: "Outline").variant(size: .small, responsive: true)
`}</code></pre>
    <p>{`F. Outline Small Not Responsive`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNOutlineBtn(title: "Outline").variant(size: .small, responsive: false)
`}</code></pre>
    <p>{`G. Outline Normal Responsive`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNOutlineBtn(title: "Outline").variant(size: .normal, responsive: false)
`}</code></pre>
    <p>{`H. Outline Normal Not Responsive`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNOutlineBtn(title: "Outline").variant(size: .normal, responsive: false)
`}</code></pre>
    <p>{`I. Soft Small Responsive`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSoftBtn(title: "Outline").variant(size: .small, responsive: true)
`}</code></pre>
    <p>{`J. Soft Small Not Responsive`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSoftBtn(title: "Outline").variant(size: .small, responsive: false)
`}</code></pre>
    <p>{`K. Soft Normal Responsive`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSoftBtn(title: "Outline").variant(size: .normal, responsive: false)
`}</code></pre>
    <p>{`L. Soft Normal Not Responsive`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSoftBtn(title: "Outline").variant(size: .normal, responsive: false)
`}</code></pre>
    <p>{`M. Transparent Small Responsive`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNTransparentBtn(title: "Outline").variant(size: .small, responsive: true)
`}</code></pre>
    <p>{`N. Transparent Small Not Responsive`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNTransparentBtn(title: "Outline").variant(size: .small, responsive: false)
`}</code></pre>
    <p>{`O. Transaparent Normal Responsive`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNTransparentBtn(title: "Outline").variant(size: .normal, responsive: true)
`}</code></pre>
    <p>{`P. Transaparent Normal Not Responsive`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNTransparentBtn(title: "Outline").variant(size: .normal, responsive: false)
`}</code></pre>
    <h3><strong parentName="h3">{` Icon `}</strong></h3>
    <div {...{
      "className": "wrapper-display-component-three",
      "style": {
        "backgroundColor": "white"
      }
    }}>{`
  `}<div parentName="div" {...{
        "className": "item-three"
      }}>{`
    `}<div parentName="div" {...{
          "style": {
            "textAlign": "left"
          }
        }}>{`Center Icon`}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F58f8c638-7de5-4e62-a6ec-806e663a7aa2%2FUntitled.png?table=block&id=1979fe29-478d-44e5-a678-b3497d03ab1c&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=770&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F3481a329-cd71-4222-826f-0b483d9945dd%2FUntitled.png?table=block&id=866f0161-831a-4136-afdd-95ebf72729a7&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=770&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2Fe1b2ca35-0f81-488e-b0ec-65867303056a%2FUntitled.png?table=block&id=4140842b-1612-4e78-958f-7587f3de1b2c&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=480&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "0px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F9476a433-f28a-4cd2-b15c-36a72738bb8a%2FUntitled.png?table=block&id=68d3fa85-24ad-412c-beaf-d1fd3a8b5b65&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=770&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
  `}</div>{`
  `}<div parentName="div" {...{
        "className": "item-three"
      }}>{`
    `}<div parentName="div" {...{
          "style": {
            "textAlign": "left"
          }
        }}>{`Left Icon`}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F3f6f0efd-c7bd-435c-b57e-4c545e3acb57%2FUntitled.png?table=block&id=606b55cd-0b54-4c1a-bfba-fdd818823a9d&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=780&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2Ff28ca110-6dbe-4c4c-b6c6-39a6f4909df1%2FUntitled.png?table=block&id=b1db6a42-a639-4184-806f-85f5c47548ae&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=770&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F54bc76c2-9c24-4ca1-b2f4-ffb19837c35d%2FUntitled.png?table=block&id=53e3bd10-3fae-47fa-979e-3764674e6d12&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=770&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "0px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F7cab7575-60e3-4e54-9cf9-7adaf2402629%2FUntitled.png?table=block&id=c21f8c29-b974-4111-9221-03fb9f9bfd1b&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=770&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
  `}</div>{`
  `}<div parentName="div" {...{
        "className": "item-three"
      }}>{`
    `}<div parentName="div" {...{
          "style": {
            "textAlign": "left"
          }
        }}>{`Right Icon`}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F7fb20676-7fa4-42e7-a04d-14bdd971881b%2FUntitled.png?table=block&id=d37590f4-818c-42dc-81f7-512a69e3bf83&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=770&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F4ad8cdd0-0999-4c0a-ac7c-27938de8db3d%2FUntitled.png?table=block&id=442cc4e5-96e1-4df0-b286-46591fff5328&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=770&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "5px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F6e1a4de7-7ef1-48db-9957-fa6f9cce78b9%2FUntitled.png?table=block&id=0eb801c4-ddfa-4c00-8ac0-3dec721022c0&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=770&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "0px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F392a8207-6a6f-4e22-aad1-dd8fcf5038c9%2FUntitled.png?table=block&id=a4665944-647a-4234-8558-5b6116adf47c&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=770&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
  `}</div>
    </div>
    <p>{`This icon attribute for user to choose the icon position inside the button.`}</p>
    <p>{`Choose type botton : `}<inlineCode parentName="p">{`LGNSolidBtn`}</inlineCode>{`, `}<inlineCode parentName="p">{`LGNOutlineBtn`}</inlineCode>{`, `}<inlineCode parentName="p">{`LGNSoftBtn`}</inlineCode>{`, `}<inlineCode parentName="p">{`LGNTransparentBtn`}</inlineCode>{` and add `}<inlineCode parentName="p">{`title`}</inlineCode>{` for the text of the button and icon position `}<inlineCode parentName="p">{`centerImage`}</inlineCode>{`, `}<inlineCode parentName="p">{`leftImage`}</inlineCode>{`, `}<inlineCode parentName="p">{`rightImage`}</inlineCode></p>
    <p>{`This code sample demonstrates how to modify icon of the button :`}</p>
    <p>{`A. Solid Button Center`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSolidBtn(
        title: "Download",
        centerImage: Image(systemName: "square.and.arrow.down")
    )
`}</code></pre>
    <p>{`B. Outline Show Acitivy`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSolidBtn(
        title: "Download",
        leftImage: Image(systemName: "square.and.arrow.down")
    )
`}</code></pre>
    <p>{`C. Solid Button Right`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSolidBtn(
        title: "Download",
        rightImage: Image(systemName: "square.and.arrow.down")
    )
`}</code></pre>
    <p>{`D. Outline Button Center`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNOutlineBtn(
        title: "Download",
        centerImage: Image(systemName: "square.and.arrow.down")
    )
`}</code></pre>
    <p>{`E. Outline Button Left`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNOutlineBtn(
        title: "Download",
        leftImage: Image(systemName: "square.and.arrow.down")
    )
`}</code></pre>
    <p>{`F. Outline Button Right`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNOutlineBtn(
        title: "Download",
        leftImage: Image(systemName: "square.and.arrow.down")
    )
`}</code></pre>
    <p>{`G. Soft Button Center`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSoftBtn(
        title: "Download",
        centerImage: Image(systemName: "square.and.arrow.down")
    )
`}</code></pre>
    <p>{`H. Soft Button Left`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSoftBtn(
        title: "Download",
        leftImage: Image(systemName: "square.and.arrow.down")
    )
`}</code></pre>
    <p>{`I. Soft Button Right`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSoftBtn(
        title: "Download",
        rightImage: Image(systemName: "square.and.arrow.down")
    )
`}</code></pre>
    <p>{`J. Transparent Button Center`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNTransparentBtn(
        title: "Download",
        centerImage: Image(systemName: "square.and.arrow.down")
    )
`}</code></pre>
    <p>{`K. Transparent Button Left`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNTransparentBtn(
        title: "Download",
        leftImage: Image(systemName: "square.and.arrow.down")
    )
`}</code></pre>
    <p>{`L. Transparent Button Right`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNTransparentBtn(
        title: "Download",
        rightImage: Image(systemName: "square.and.arrow.down")
    )
`}</code></pre>
    <h3><strong parentName="h3">{` Show Activity `}</strong></h3>
    <div {...{
      "className": "wrapper-display-component-three",
      "style": {
        "backgroundColor": "white"
      }
    }}>{`
  `}<div parentName="div" {...{
        "className": "item-three"
      }}>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "7px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2Faa5ae162-3151-4af8-9e55-913bb1b7cecf%2FUntitled.png?table=block&id=7df08706-3536-4a20-95a2-2111702e040b&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=780&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "textAlign": "left"
          }
        }}>{`Solid`}</div>{`
  `}</div>{`
  `}<div parentName="div" {...{
        "className": "item-three"
      }}>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "7px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2Fbdce23fc-89e4-4872-8acc-2854aba9f138%2FUntitled.png?table=block&id=cc71e0d1-c706-4d9e-83b9-86a46f891b23&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=780&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "textAlign": "left"
          }
        }}>{`Outline`}</div>{`
  `}</div>{`
  `}<div parentName="div" {...{
        "className": "item-three"
      }}>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "7px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2Fdd6cf72e-ac6f-40e9-af85-8845d76b6f61%2FUntitled.png?table=block&id=b5355c08-e550-4395-9e5a-b7440fb54240&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=780&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "textAlign": "left"
          }
        }}>{`Soft`}</div>{`
  `}</div>{`
  `}<div parentName="div" {...{
        "className": "item-three"
      }}>{`
    `}<div parentName="div">{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2Fc0df2349-7dc9-49a1-a720-5717c4ac3597%2FUntitled.png?table=block&id=eb518d87-d2f9-421a-8c0d-580d8519e7b1&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=770&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "textAlign": "left"
          }
        }}>{`Transaparent`}</div>{`
  `}</div>
    </div>
    <p>{`Choose type botton : `}<inlineCode parentName="p">{`LGNSolidBtn`}</inlineCode>{`, `}<inlineCode parentName="p">{`LGNOutlineBtn`}</inlineCode>{`, `}<inlineCode parentName="p">{`LGNSoftBtn`}</inlineCode>{`, `}<inlineCode parentName="p">{`LGNTransparentBtn`}</inlineCode>{` and add : `}<inlineCode parentName="p">{`.showProgressView(true)`}</inlineCode>{` consists for `}<inlineCode parentName="p">{`true`}</inlineCode></p>
    <p>{`This code sample demonstrates how to modify show activity of the button :`}</p>
    <p>{`A. Solid Show Activity`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSolidBtn(title: "Title").showProgressView(true)
`}</code></pre>
    <p>{`B. Outline Show Acitivy`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNOutlineBtn(title: "Title").showProgressView(true)
`}</code></pre>
    <p>{`C. Soft Show Activity`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSoftBtn(title: "Title").showProgressView(true)
`}</code></pre>
    <p>{`D. Transparent Show Activity`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNTransparentBtn(title: "Title").showProgressView(true)
`}</code></pre>
    <h3><strong parentName="h3">{` Disable `}</strong></h3>
    <div {...{
      "className": "wrapper-display-component-three",
      "style": {
        "backgroundColor": "white"
      }
    }}>{`
  `}<div parentName="div" {...{
        "className": "item-three"
      }}>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "7px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F6e2a0b7a-0146-4b2a-afbb-a77b6d147556%2FUntitled.png?table=block&id=b0599805-4866-40dd-ab39-6493eff892fb&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=770&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "textAlign": "left"
          }
        }}>{`Solid`}</div>{`
  `}</div>{`
  `}<div parentName="div" {...{
        "className": "item-three"
      }}>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "7px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2Fff0df2f7-70f4-4803-96e6-2b3323f78a5e%2FUntitled.png?table=block&id=49d379f8-7d62-4f31-b128-b804545b45a2&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=770&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "textAlign": "left"
          }
        }}>{`Outline`}</div>{`
  `}</div>{`
  `}<div parentName="div" {...{
        "className": "item-three"
      }}>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "7px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2Ffad12ae6-7103-4566-8020-fc70e6014f39%2FUntitled.png?table=block&id=0f6de255-5adc-4a2c-9734-b365665b607f&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=770&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "textAlign": "left"
          }
        }}>{`Soft`}</div>{`
  `}</div>{`
  `}<div parentName="div" {...{
        "className": "item-three"
      }}>{`
    `}<div parentName="div">{`
      `}<img parentName="div" {...{
            "src": "https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2Ff0914de4-ea53-48c8-8cad-0f5e56445aa9%2FUntitled.png?table=block&id=348ff92d-9ca1-4c65-a43e-3e6627c5f860&spaceId=35a14a17-7ee4-461e-a539-293d39e34c63&width=770&userId=00fada7e-1357-4bc5-acbd-74e1e4633cb0&cache=v2"
          }}></img>{`
    `}</div>{`
    `}<div parentName="div" {...{
          "style": {
            "textAlign": "left"
          }
        }}>{`Transaparent`}</div>{`
  `}</div>
    </div>
    <p>{`Choose type botton : `}<inlineCode parentName="p">{`LGNSolidBtn`}</inlineCode>{`, `}<inlineCode parentName="p">{`LGNOutlineBtn`}</inlineCode>{`, `}<inlineCode parentName="p">{`LGNSoftBtn`}</inlineCode>{`, `}<inlineCode parentName="p">{`LGNTransparentBtn`}</inlineCode>{` and add : `}<inlineCode parentName="p">{`.disableInteraction`}</inlineCode>{` consists for `}<inlineCode parentName="p">{`true`}</inlineCode></p>
    <p>{`This code sample demonstrates how to modify disable of the button :`}</p>
    <p>{`A. Solid Disable`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSolidBtn(title: "Title").disableInteraction(true)
`}</code></pre>
    <p>{`B. Outline Disable`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNOutlineBtn(title: "Title").disableInteraction(true)
`}</code></pre>
    <p>{`C. Soft Disable`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    LGNSoftBtn(title: "Title").disableInteraction(true)
`}</code></pre>
    <p>{`D. Transparent Disable`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`   LGNTransparentBtn(title: "Title").disableInteraction(true)
`}</code></pre>
    <div className="divi" />
    <h2>{`Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Properties`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`action`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The action to perform when the user triggers the button.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{}`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`title`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The title for the button’s title, that describes the purpose of the button’s `}<inlineCode parentName="td">{`action`}</inlineCode>{`.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`-`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`textFont`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To change the font on the title button.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Font.system(size: 16, weight: .bold, design: .default)`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tintBtnColor`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To change the tint color of button.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Color.white`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`defaultBtnColor`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To change the tint color of button.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Color.primary500`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`focusBtnColor`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To change the background color of the button when the button is in focus state.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Color.primary700`}</inlineCode></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      